function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import YoutubeVideoWithPosterComponent from "components/core/youtube-video-with-poster/youtube-video-with-poster-component";
import ColorfulTitleComponent from "/components/core/colorful-title/colorful-title-component";
import LottieAnimationComponent from "../lottie-animtaion/lottie-animation-component";
import VideoDecoration from "/static/svg/decorators/main-video/top-left-decoration.svg";
import { StyledMainYoutubeVideoComponent } from "./main-youtube-video-component.scss";
const LOTTIE_ANIMATION_CONFIG = {
    animation: {
        jsonPath: "/static/lottie/arrow-turn-left.json",
        loop: false,
        autoplay: false,
        playOnlyWhenVisible: true
    },
    style: {}
};
class MainYoutubeVideoComponent extends PureComponent {
    render() {
        const { youtubeVideoId, poster, showDecorations, title, animationText, width, height } = this.props;
        return /*#__PURE__*/ _jsxs(StyledMainYoutubeVideoComponent, {
            width: width,
            height: height,
            className: "main-youtube-video-component",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "video-component-wrapper",
                    children: [
                        showDecorations && /*#__PURE__*/ _jsx("div", {
                            className: "video-decoration-wrapper",
                            children: /*#__PURE__*/ _jsx(VideoDecoration, {})
                        }),
                        /*#__PURE__*/ _jsx(YoutubeVideoWithPosterComponent, {
                            videoId: youtubeVideoId,
                            poster: poster,
                            muted: false,
                            volume: 100
                        }),
                        showDecorations && /*#__PURE__*/ _jsxs("div", {
                            className: "lottie-animation-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx(LottieAnimationComponent, _object_spread({}, LOTTIE_ANIMATION_CONFIG)),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "animation-text",
                                    children: animationText
                                })
                            ]
                        })
                    ]
                }),
                title && /*#__PURE__*/ _jsx(ColorfulTitleComponent, {
                    className: "main-video-title",
                    text: title
                })
            ]
        });
    }
}
export { MainYoutubeVideoComponent as default };
MainYoutubeVideoComponent.defaultProps = {
    showDecorations: true,
    youtubeVideoId: "1UbaEcto56k",
    poster: "/static/img/templates/long-template/segments/boards/board-with-cactus-and-phone.png",
    title: "monday.com in 60 sec",
    animationText: "Take a tour",
    width: "1050px",
    height: "570px"
};
